import React, {forwardRef} from 'react';
import {translateNativeBase} from "../../../services/nativeBaseTranslator";

const HStack = forwardRef((props, ref) => {
    const { children, key, nativeID, style = {}, onClick, ...rest } = props;
    return (
        <div key={key} id={nativeID} ref={ref} onClick={onClick} style={{display: "flex", flexDirection: 'row', ...translateNativeBase({...rest}), ...style}}>
            {children}
        </div>
    );
});

export default HStack;